import { put, call, select } from 'redux-saga/effects';
// eslint-disable-next-line no-unused-vars
import { getPrioritiesRequest, getPrioritiesSuccess, getPrioritiesFailure } from '../actions/priorities';
import { getPriorities } from '../services/priorities';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { prioritiesSelector } from '../selectors/priorities';

export const getPrioritiesWorker = function*({ payload: { filters = {} } = {} } = {}) {
    try {
        const { priorities: _priorities } = yield select(prioritiesSelector);

        if (!_priorities.length) {
            yield put(getPrioritiesRequest());

            const token = yield select(accessTokenSelector);

            const { data } = yield call(getPriorities, filters, token);

            // yield put(getPrioritiesSuccess(statuses));
        }
    } catch (err) {
        yield put(getPrioritiesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [getPrioritiesWorker];
